import { Component, Input, OnInit, ViewChild, OnChanges, HostListener, SimpleChanges } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { constObj } from '../../Constants/constants';
import { CommonDataService } from '../../services/common-data.service';
import { SttSortingService } from '../../services/stt-sorting.service';
@Component({
  selector: 'app-stt-table',
  templateUrl: './stt-table.component.html',
  styleUrls: ['./stt-table.component.css']
})
export class SttTableComponent implements OnInit, OnChanges {

  @Input() table_Columns: any;
  @Input() table_dataSource: MatTableDataSource<any>;
  @Input() table_data: any;
  @Input() OPColumn: string;
  @Input() CodColumn: string;
  @Input() CIGColumn: string;
  @Input() Collection: string;
  @Input() hideCIGFromSTTs: boolean;
  SelectedSearch: string = '';
  // @ViewChild(MatPaginator) paginator: MatPaginator;
  // @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  noRecords = constObj.Norecords;
  data_length: number;
  displayedColumns: any;
  matHeaderRowDefs:any = [];
  dataSource: any = [];
  hideSTTCIG: boolean;
  constructor(private commonDataService: CommonDataService, private router: Router, private sttSort: SttSortingService) {
    this.dataSource = new MatTableDataSource<any>();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.SelectedSearch = this.commonDataService.currentSortHeaderSTT.getValue();
    this.sortingColumn = this.SelectedSearch == "OP" ? "pronouncement" : (this.SelectedSearch == "COD" ? "section" : (this.SelectedSearch == "CIG" ? "chapter" : "pronouncement"));
    this.sortingDirection = this.commonDataService.currentSortDirectionSTT.getValue() == '' || this.commonDataService.currentSortDirectionSTT.getValue() == 'asc' ? 'asc' : 'desc';
    if (changes.table_data != undefined) {
      this.dataSource.data = changes.table_data.currentValue.sort((a, b) => this.sortProcess(a, b, this.sortingDirection));
      this.data_length = this.dataSource.length;
      if (this.hideSTTCIG)
        this.matHeaderRowDefs = ['header-row-OP', 'header-row-Cod'];
      else
        this.matHeaderRowDefs = ['header-row-OP', 'header-row-Cod', 'header-row-CIG'];
      this.displayedColumns = this.table_Columns.map((c) => c.columnDef);
      this.table_dataSource.paginator = this.paginator;
      this.table_dataSource.sort = this.sort;
      this.table_dataSource.sortData = this.sortData();
    }
  }
  customTrackBy(index, item) { return item.columnDef; }

  pagesize: any = 10;
  pagelistarray: any[] = [];
  ngOnInit(): void {
    this.hideSTTCIG = this.hideCIGFromSTTs;
    
    if (this.hideSTTCIG)
      this.matHeaderRowDefs = ['header-row-OP', 'header-row-Cod'];
    else
      this.matHeaderRowDefs = ['header-row-OP', 'header-row-Cod', 'header-row-CIG'];

    this.SelectedSearch = this.commonDataService.currentSortHeaderSTT.getValue();
    this.sortingColumn = this.SelectedSearch == "OP" ? "pronouncement" : (this.SelectedSearch == "COD" ? "section" : (this.SelectedSearch == "CIG" ? "chapter" : "pronouncement"));
    this.sortingDirection = this.commonDataService.currentSortDirectionSTT.getValue() == '' || this.commonDataService.currentSortDirectionSTT.getValue() == 'asc' ? 'asc' : 'desc';
    if (this.table_data != null && this.table_data != undefined) {
      this.table_data.sort((a, b) => this.sortProcess(a, b, this.sortingDirection));
    }
    this.dataSource.data = this.table_data;
    this.data_length = this.dataSource.length;
    this.displayedColumns = this.table_Columns?.map((c) => c.columnDef);
    this.filterAccordianrows();
  }

  sortingColumn: string = "";
  sortingDirection: any = 'asc';
  customSort(event) {
    this.sortingColumn = event.active;
    if (this.sortingColumn == "pronouncement") { this.commonDataService.currentSortHeaderSTT.next("OP"); }
    else if (this.sortingColumn == "section") { this.commonDataService.currentSortHeaderSTT.next("COD"); }
    else if (this.sortingColumn == "chapter") { this.commonDataService.currentSortHeaderSTT.next("CIG"); }
    this.sortingDirection = event.direction;
    if (this.sortingDirection == 'asc' || this.sortingDirection == '') { this.commonDataService.currentSortDirectionSTT.next('asc'); }
    else { this.commonDataService.currentSortDirectionSTT.next('desc'); }
  }

  sortData() {
    let sortFunction =
      (items: any[], ms: MatSort) => {
        if (!ms.active || ms.direction === '') {
          return items;
        }
        return items.sort((a: any, b: any) => {
          return this.sortProcess(a, b, ms.direction);
        });
      };
    return sortFunction;
  }

  //private paginator: MatPaginator;
  //private sort: MatSort;
  filterAccordianrows() {
    this.pagelistarray = [];
    this.pagesize = 10;
    if (this.table_data?.length > 10) {
      this.pagelistarray = [10, 20, this.table_data?.length];
    }
  }

  sortProcess(a: any, b: any, direction) {
    let comparatorResult = 0;
    if (this.sortingColumn == "section") {
      comparatorResult = this.sttSort.SortSTTbySection(a, b);
      if (comparatorResult == 0) {
        comparatorResult = this.sttSort.SortSTTbyPronouncement(a, b);
        if (comparatorResult == 0) {
          if (a.pronouncementPara != undefined && b.pronouncementPara != undefined) {
            comparatorResult = this.sttSort.SortSTTbyParagraph(a, b, direction);
            if (comparatorResult == 0) {
              comparatorResult = this.sttSort.SortSTTbyChapter(a, b);
            }
          }
          else {
            comparatorResult = this.sttSort.SortSTTbyChapter(a, b);
          }
        }
      }
    }
    else if (this.sortingColumn == "chapter") {
      comparatorResult = this.sttSort.SortSTTbyChapter(a, b);
      if (comparatorResult == 0) {
        comparatorResult = this.sttSort.SortSTTbyPronouncement(a, b);
        if (comparatorResult == 0) {
          if (a.pronouncementPara != undefined && b.pronouncementPara != undefined) {
            comparatorResult = this.sttSort.SortSTTbyParagraph(a, b, direction);
            
          }
          else {
            comparatorResult = this.sttSort.SortSTTbySection(a, b);
          }
        }
      }
    }
    else if (this.sortingColumn == "pronouncement") {
      comparatorResult = this.sttSort.SortSTTbyPronouncement(a, b);
      if (comparatorResult == 0) {
        if (a.pronouncementPara != undefined && b.pronouncementPara != undefined) {
          comparatorResult = this.sttSort.SortSTTbyParagraph(a, b, direction);
          if (comparatorResult == 0) {
            comparatorResult = this.sttSort.SortSTTbySection(a, b);
            if (comparatorResult == 0) {
              comparatorResult = this.sttSort.SortSTTbyChapter(a, b);
            }
          }
        }
        else
        {
          comparatorResult = this.sttSort.SortSTTbySection(a, b);
          if (comparatorResult == 0) {
            comparatorResult = this.sttSort.SortSTTbyChapter(a, b);
          }
        }
      }
    }
    return comparatorResult * (direction == 'asc' ? 1 : -1);
  }

  

  //@ViewChild(MatSort) set matSort(ms: MatSort) {
  //  this.sort = ms;
  //  this.setDataSourceAttributes();
  //}

  //@ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
  //  this.paginator = mp;
  //  this.setDataSourceAttributes();
  //}

  //setDataSourceAttributes() {
  //  this.table_dataSource.paginator = this.paginator;
  //  this.table_dataSource.sort = this.sort;
  //}

  ngAfterViewInit() {
    if (this.table_dataSource != null && this.table_dataSource != undefined) {
      this.table_dataSource.paginator = this.paginator;
      this.table_dataSource.sort = this.sort;
      this.table_dataSource.sortData = this.sortData();
    }
  }

  redirectInlineGlossary(id) {
    this.commonDataService.rightOverlayOption.next("inline-glossary");
    this.commonDataService.rightPanelWidth.next("rightOverLay_small");
    this.commonDataService.glossaryTermId.next(id);
    this.commonDataService.showRightPanel.next(true);
  }

  redirectContentPage(path) {
    if (!path.split("\\")[2].includes("GUID") && path.split("\\")[2] != "") {
      let url = "/" + path.split("\\")[1] + "/" + path.split("\\")[2];
      if (path.split("\\").length > 3) {
        url = url + "/" + path.split("\\")[3];
      }
      //this.commonDataService.isSourceTracingLinkClicked.next(true);
      //this.router.navigateByUrl(url);
      var baseUrl = window.location.origin;
      window.open(baseUrl + url)
    }

  }
  
  onRowCellClick(row: any, className: string, event: any) {
    // row contains all columns/fields for that record
    event.preventDefault();
    event.target.removeAttribute('href');
    var is_inline_glossary_tags_exists = event?.target?.classList?.contains('term');
    var linkId = event?.target?.dataset?.link;
    if (is_inline_glossary_tags_exists) {

      this.commonDataService.glossaryTermId.next("");
      if (linkId != "" && linkId != null) {
        this.commonDataService.glossaryTermId.next(linkId);
      }
      this.redirectInlineGlossary(linkId);
    }
    var is_content_page_tags_exists = event?.target?.classList?.contains('contentPage');
    if (is_content_page_tags_exists) {
      if (!(row.paraType.includes('Glossterm'))) {
        this.redirectContentPage(linkId);
      }
      if (row.paraType.includes('Glossterm')) {
        const text = (event.target.innerHTML).trim();
        const temp = document.createElement('div');
        temp.innerHTML = row.chapter;
        const chaptertext = temp.textContent?.trim();
        console.log("chapter text: ", chaptertext);

        if (!chaptertext.toLowerCase().startsWith('glossary') && !className.includes("pronouncement")) {
          linkId = linkId.split(/[/\\]+/).filter(Boolean).pop() ?? '';
          this.redirectInlineGlossary(linkId);
        }
        if (chaptertext.toLowerCase().startsWith('glossary') || className == "pronouncement" || className == "pronouncementPara") {
          this.redirectContentPage(linkId);
        }
      }
    }
  }

  @HostListener('contextmenu', ['$event']) RightClick(event: any) {
    var is_inline_glossary_tags_exists = event?.target?.classList?.contains('term');
    var linkId = event?.target?.dataset?.link;
    if (is_inline_glossary_tags_exists) {
      return false;
    }

    var is_content_page_tags_exists = event?.target?.classList?.contains('contentPage');
    if (is_content_page_tags_exists) {
      if (!linkId.split("\\")[2].includes("GUID") && linkId.split("\\")[2] != "") {
        let url = "/" + linkId.split("\\")[1] + "/" + linkId.split("\\")[2];
        if (linkId.split("\\").length > 3) {
          url = url + "/" + linkId.split("\\")[3];
        }
        event.target.setAttribute('href', url);
      }
    }
  }
}
